import GET_ARTICLES from "../class/getArticles";
import Swiper from "swiper/bundle";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];

const domReady = TPL => {
  new BLOCKS;
  instaAPI();
};

class BLOCKS{
  constructor() {
    this.mainvisual();
    this.news();
    this.parallax();
  }

  mainvisual() {
    const mainVisual = document.querySelector('.mainvisual');
    if (!mainVisual) return;

    const showMainVisual = () => {
      setTimeout(() => {
        mainVisual.classList.add('loaded');
      }, 100);
    };

    if (document.readyState === 'complete') {
      showMainVisual();
    } else {
      window.addEventListener('load', showMainVisual);
    }

    const mvSlide = new Swiper('.mv_slide[data-plugin="mainSlider"]', {
      loop: true,
      effect: 'fade',
      speed: 1200,
      allowTouchMove: false,
      fadeEffect: { crossFade: true },
      watchSlidesProgress: true, 
      updateOnImagesReady: true, 
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        waitForTransition: false
      },
    });

    const news_ticker = new GET_ARTICLES('.news-article[data-plugin="getArticles"]');
    news_ticker.makeItem = (item) => `
      <a class="news-link" href="${item.href}">
        <p class="info">
          <span class="date">${item.date}</span>
          <span class="cat">${item.category.name}</span>
        </p>
        <p class="title">${item.title}</p>
        <img src="/assets/svg/icon_arrow.svg" alt="矢印" width="22">
      </a>`;
    news_ticker.render();

    const news_pickup = new GET_ARTICLES('.news-pickup');
    const pickupWrapper = document.querySelector('.block-pickup-wrap');
    let isDisplayed = false;

    news_pickup.makeItem = (item) => {
      const categoryName = item.category.name.trim();
      if (isDisplayed || categoryName !== 'PICK UP') return '';

      isDisplayed = true;
      if (pickupWrapper) pickupWrapper.style.display = 'block';

      return `
        <div class="pickup-link">
          <img class="pickup_circle" src="/assets/img/top/pickup_circle@2x.png" alt="PICK UP" loading="lazy">
          <figure><img src="${item.thumb}" alt="${item.title}" loading="lazy"></figure>
          <div class="pickup-link-wrap">
            <h2 class="top_ttl"><strong>PICK UP</strong><span>ピックアップ</span></h2>
            <p class="title">${item.title}</p>
            <span class="desc">${item.desc}</span>
            <a href="${item.href}" class="viewmore">
              <span>View More</span>
              <svg class="icon arrow arrow_view"><use xlink:href="/assets/svg/sprite.symbol.svg#icon_arrow_long"></use></svg>
            </a>
          </div>
        </div>`;
    };
    news_pickup.render();
    } 

    // ニュース4件表示
  news() {
    const getArticle = new GET_ARTICLES('.block-news__list');
    getArticle.makeItem = (item) => {
      const articleBody = item.body ? item.body.replace(/<[^>]+>/g, '').slice(0, 88) + '...' : '';
      
      return `
      <li class="block-news__item">
        <a href="${item.href}" class="block-news__link">
          <figure class="thumb">
            <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy">
          </figure>
          <p class="ttl${(item.is_new) ? ' is-new' : ''}"><span>${item.title}</span></p>
          <div class="text_wrap">
            <span class="date">${item.date}</span>
            <p class="cate">${item.category.name}</p>
          </div> 
        </a>
      </li>`;
    };
    getArticle.render();
  }

  parallax() {
    const containers = document.querySelectorAll('.js-parallax-container');
    if (containers.length === 0) return;

    const render = () => {
      containers.forEach(container => {
        const img = container.querySelector('.js-parallax-img');
        if (!img) return;

        const rect = container.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (rect.top < windowHeight && rect.bottom > 0) {
          
          const distanceFromTop = windowHeight - rect.top; 
          const totalDistance = windowHeight + rect.height; 
          const progress = distanceFromTop / totalDistance; 

          const moveRange = 15; 
          const yPosPercent = (progress - 0.5) * moveRange * 2; 

          img.style.transform = `translate3d(0, ${yPosPercent}%, 0)`;
        }
      });
      requestAnimationFrame(render); 
    };

    render();
  }
}

// instaAPI
async function instaAPI() {
  const container = d.getElementById('insta');
  container.innerHTML = "";
  container.insertAdjacentHTML('beforeend', '<ul id="instafeed" class="block-insta-feed"></ul>');
  
  const cards = 9; // insta投稿の表示件数を指定
  const businessId = '17841449509384596';
  // 個人アカウント
  const token = 'EAAXL9ZAuWPg4BSMZBFLOZBAAZBB9Hyx9UV7fwAoIRSdw5kHwTOoBzZBAXHoj69XCWpuQNZCwa6CUYFB0sgpA4F1CFH4vmJQOxkob1ke0uY54DL6OKkQXyGeYx3xYY5jHntrwkLqJZAhHGOkI6C0NCeuynthmKwsJ6SnnLlqB3wFhMZCiVMsEZCisMMZAt9sNvMhpE6OZAkYZA7OU5c8p';
  // システムユーザー
  // const token = 'EAAXAZABXa3oMBQCm1Fj7QMq3y4raw2LqbfdZCgINUKA1XSHSEjjKSE8jUtFvZADYdNBJCicsAIjxEwn8kVEqs6enwnGWN1ZC62qwT7NLbY5ZCtNk2YboENuGCZB4AkWFqF7TTO7FGNbCYu9J2PREOKsnszUsRFNaOonHZB1Wwe3enxlfSWZBosjKIg8oB4qHhSQhGzGht2CUWMU5R0jeGLEPChPp5jj1Rfqn1eQb';
  const response = await fetch(
    `https://graph.facebook.com/v19.0/${businessId}?fields=name,media.limit(${cards}){ caption,media_url,thumbnail_url,permalink,like_count,comments_count,media_type}&access_token=${token}`
  );
  
  if (response.status === 200) {
    const resObjects = await response.json();
    //（挙動への影響は一切無いものの）オブジェクト{resObjects.media}内のプロパティ{paging}のせいで「instaItems[1]が無いというエラー」が出るので削除して以降の処理を進めていく
    delete resObjects.media.paging;
  
    Object.entries(resObjects.media).forEach((instaItems) => {
      instaItems[1].forEach((eachItem) => {
        if (eachItem.media_url !== null) {
          // 投稿が動画か否かを判定して{media}を変更
          if (eachItem.media_type === 'VIDEO') {
            eachItem.media = eachItem.thumbnail_url;
          } else {
            eachItem.media = eachItem.media_url;
          }

          document
            .querySelector('#instafeed')
            .insertAdjacentHTML(
              'beforeend',
              `<li><a href="${eachItem.permalink}" target="_blank" rel="noopener"><figure><img src="${eachItem.media}" alt="${eachItem.caption}" loading="lazy"></figure></a></li>`
            );
        }
      });
    });
  } else {
    container.insertAdjacentHTML(
      'beforeend',
      `<p style="text-align:center;width:100%;">読み込めませんでした</p>`
    );
  }
}


const jqInit = () => false;

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());
}